import React, { useState, useEffect } from "react";
import {
  changePassword,
  resetPasswordChangeMessage,
} from "../../../store/slices/authSlice";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePasswordModal = ({ show, handleClose }) => {
  const [data, setData] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
    userId: "",
    token: "",
  });
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    password: false,
    confirmPassword: false,
  });
  const dispatch = useDispatch();
  const { userInfo, passwordChangeSuccessMessage, passwordChangeErrorMessage, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (passwordChangeSuccessMessage) {
      showToastifySuccess(passwordChangeSuccessMessage);
      dispatch(resetPasswordChangeMessage(null));
    }
    if (passwordChangeErrorMessage) {
      showToastifyError(passwordChangeErrorMessage);
      dispatch(resetPasswordChangeMessage(null));
    }
  }, [dispatch, passwordChangeSuccessMessage, passwordChangeErrorMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      changePassword({
        oldPassword: data.oldPassword,
        password: data.password,
        confirmPassword: data.confirmPassword,
        userId: userInfo?._id,
        token
      })
    );
    handleClose();
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="currentPassword">
            <Form.Label>Current Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="oldPassword"
                type={showPassword.oldPassword ? "text" : "password"}
                placeholder="Enter current password"
                value={data.oldPassword}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("oldPassword")}
              >
                {showPassword.oldPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="password"
                type={showPassword.password ? "text" : "password"}
                placeholder="Enter new password"
                value={data.password}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("password")}
              >
                {showPassword.password ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d3d3d3",
                borderRadius: "0.5rem",
              }}
            >
              <Form.Control
                name="confirmPassword"
                type={showPassword.confirmPassword ? "text" : "password"}
                placeholder="Confirm new password"
                value={data.confirmPassword}
                onChange={handleChange}
                style={{ flex: 1, border: "none" }}
                required
              />
              <span
                className="input-group-text"
                onClick={() => toggleShowPassword("confirmPassword")}
              >
                {showPassword.confirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </Form.Group>
          <Button variant="primary" type="submit">
            Change Password
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePasswordModal;